export const QUEUED = 'queued';
export const LOADING = 'loading';
export const READY = 'loaded';